<div class="content">
	<article class="headlines">
		<h1>404</h1>
		<h3  i18n="@@page_not_found.title">Page not found</h3>
	</article>
	<div class="descriptions">
		<p i18n="@@page_not_found.description">Sorry, the page you are looking for does not exist.</p>
	</div>
</div>
